export default {"src":"/_next/static/media/paypalLogo.0bc39661.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};